/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { CustomerStatus } from './CustomerStatus.js';
import {
    CustomerStatusFromJSON,
    CustomerStatusFromJSONTyped,
    CustomerStatusToJSON,
} from './CustomerStatus.js';

/**
 * 
 * @export
 * @interface CustomerPreview
 */
export interface CustomerPreview {
    /**
     * 
     * @type {number}
     * @memberof CustomerPreview
     */
    customerId?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomerPreview
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPreview
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPreview
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPreview
     */
    address?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerPreview
     */
    matched?: boolean;
    /**
     * 
     * @type {CustomerStatus}
     * @memberof CustomerPreview
     */
    status?: CustomerStatus;
}

/**
 * Check if a given object implements the CustomerPreview interface.
 */
export function instanceOfCustomerPreview(value: object): boolean {
    return true;
}

export function CustomerPreviewFromJSON(json: any): CustomerPreview {
    return CustomerPreviewFromJSONTyped(json, false);
}

export function CustomerPreviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomerPreview {
    if (json == null) {
        return json;
    }
    return {
        
        'customerId': json['customerId'] == null ? undefined : json['customerId'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'address': json['address'] == null ? undefined : json['address'],
        'matched': json['matched'] == null ? undefined : json['matched'],
        'status': json['status'] == null ? undefined : CustomerStatusFromJSON(json['status']),
    };
}

export function CustomerPreviewToJSON(value?: CustomerPreview | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'customerId': value['customerId'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'phoneNumber': value['phoneNumber'],
        'address': value['address'],
        'matched': value['matched'],
        'status': CustomerStatusToJSON(value['status']),
    };
}

